import React from "react";
import Box from "@mui/material/Box/Box";
import { useMediaQuery } from "@mui/material";
import { theme } from "../../special/genie-theme/genie-theme";

interface Props {
  children: React.ReactNode;
  imageUrl: string;
}
function GenieCanvas({ children, imageUrl }: Props) {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box display={"flex"} height={"100vh"} width={"100vw"}>
      <Box
        sx={{
          display: isMobile ? "none" : "block",
          backgroundSize: "cover",
          backgroundPosition: "cover",
          height: "100%",
          flexBasis: 1200,
          backgroundImage: imageUrl,
        }}
      />
      <Box
        display={"flex"}
        flexDirection={"column"}
        width={"100%"}
        alignItems={"center"}
        p={isMobile ? 8 : 0}
      >
        <Box
          maxWidth={360}
          height={"100%"}
          display={"flex"}
          alignItems={isMobile ? "initial" : "center"}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default GenieCanvas;
